var _defs, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorHeader768Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 768,
    height: 1024,
    viewBox: "0 0 768 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fff;opacity:0.24;mix-blend-mode:overlay;}.b,.c{isolation:isolate;}.c{fill:none;stroke:#fff;stroke-width:2px;opacity:0.478;mix-blend-mode:soft-light;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00cacd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0080a2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 768,
    height: 1024
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.198 96.758)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 6.75,
    cy: 6.234,
    rx: 6.75,
    ry: 6.234,
    transform: "translate(432.941 7.334)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3,
    cy: 2.771,
    rx: 3,
    ry: 2.771,
    transform: "translate(44.552 14.334)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3,
    cy: 2.771,
    rx: 3,
    ry: 2.771,
    transform: "translate(548.552 3.871)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.875,
    cy: 1.732,
    rx: 1.875,
    ry: 1.732,
    transform: "translate(304.052)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 6.75,
    cy: 6.234,
    rx: 6.75,
    ry: 6.234,
    transform: "translate(324.829 780.927)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3,
    cy: 2.771,
    rx: 3,
    ry: 2.771,
    transform: "translate(-63.56 787.928)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 3,
    cy: 2.771,
    rx: 3,
    ry: 2.771,
    transform: "translate(440.44 777.464)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 1.875,
    cy: 1.732,
    rx: 1.875,
    ry: 1.732,
    transform: "translate(259.5 891.593)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.369 108.153)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.867.346l14.9-.321a1.37,1.37,0,0,1,1.458,1.363l-.321,13.951a1.525,1.525,0,0,1-1.522,1.427l-14.9.321A1.37,1.37,0,0,1,.024,15.724L.344,1.773A1.525,1.525,0,0,1,1.867.346Z",
    transform: "translate(335.237 0) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.462,0,8.178.127A1.517,1.517,0,0,1,9.7,1.549l.129,6.268A1.378,1.378,0,0,1,8.364,9.182L1.649,9.053A1.517,1.517,0,0,1,.128,7.631L0,1.363A1.378,1.378,0,0,1,1.462,0Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 14.899)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(265.281 882.036)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.867.346l14.9-.321a1.37,1.37,0,0,1,1.458,1.363l-.321,13.951a1.525,1.525,0,0,1-1.522,1.427l-14.9.321A1.37,1.37,0,0,1,.024,15.724L.344,1.773A1.525,1.525,0,0,1,1.867.346Z",
    transform: "translate(335.237 0) rotate(17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1.462,0,8.178.127A1.517,1.517,0,0,1,9.7,1.549l.129,6.268A1.378,1.378,0,0,1,8.364,9.182L1.649,9.053A1.517,1.517,0,0,1,.128,7.631L0,1.363A1.378,1.378,0,0,1,1.462,0Z",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 14.899)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorHeader768Px);
export default __webpack_public_path__ + "static/media/errorHeader_768px.9ecdc845a5f0e63ee0109713ff2b5a4d.svg";
export { ForwardRef as ReactComponent };